module.exports = __webpack_public_path__ + "img/Walls_text06b_predZtrue.1a62490a.png";